import React from 'react';

import { useCurrentProjectId } from '@adsk/alloy-provider';
import { Text } from '@adsk/alloy-react-box';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { FEATURE_FLAGS } from './helpers/constants';
import { getFormDetailsUrl } from './helpers/utils';
import { useTemplateName } from './hooks';
import { usePlangridFeatureFlag } from './PlangridLaunchDarklyProvider';
import EntityMenuItem from '../../EntityMenuItem';

const FormsEntityMenuItem = ({ entity: form, ...rest }) => {
  const projectId = useCurrentProjectId();
  const { templateName } = useTemplateName(form);
  const { value: enableRenameForms } = usePlangridFeatureFlag(
    FEATURE_FLAGS.RENAME_FORMS,
    false,
  );
  const label = (
    <OverflowTooltip
      content={`${enableRenameForms ? form.name || templateName : templateName} #${form.report_num}`}
    >
      <Text marginRight="8px">
        {`${enableRenameForms ? form.name || templateName : templateName} #${form.report_num}`}
      </Text>
    </OverflowTooltip>
  );
  return (
    <EntityMenuItem
      link={getFormDetailsUrl(projectId, form.type, form.uid)}
      label={label}
      {...rest}
    />
  );
};

export default FormsEntityMenuItem;
